<template>
  <div>
    <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290">
      <template #activator="{ props }">
        <v-text-field v-model="formattedDate" label="Select Date" prepend-inner-icon="mdi-calendar" readonly v-bind="props"></v-text-field>
      </template>

      <v-date-picker elevation="24" color="primary" v-model="date" @update:model-value="updateDate"></v-date-picker>
    </v-menu>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const menu = ref(false);
const date = ref(null);
const formattedDate = ref('');

function updateDate(newDate) {
  const d = new Date(newDate);
  formattedDate.value = d.toLocaleDateString();
  menu.value = false;
}
</script>
